import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withSetting = <P extends Record<string, any>>(
  Component: React.ComponentType<P>,
  setting: 'inverted'
): React.ComponentType<P> => {
  const settingClass = `setting--${setting}`;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ComponentWithSetting = React.forwardRef<React.ComponentType<P>, any>((props: P, ref) => (
    <Component {...props} ref={ref} className={[props.className, settingClass].join(' ').trim()} />
  ));

  ComponentWithSetting.displayName = `withSetting(${Component.displayName || 'Component'})`;

  return ComponentWithSetting;
};
